import { render, staticRenderFns } from "./ContentManageBanner.vue?vue&type=template&id=0c536c8a&"
import script from "./ContentManageBanner.vue?vue&type=script&lang=js&"
export * from "./ContentManageBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports